import './redirector-app-popover.css';

import './img/bkg.png';
import './img/compfight.svg';
import './img/photopin.svg';
